import { render, staticRenderFns } from "./Palette.vue?vue&type=template&id=0abc3d60&scoped=true&"
import script from "./Palette.vue?vue&type=script&lang=js&"
export * from "./Palette.vue?vue&type=script&lang=js&"
import style0 from "./Palette.vue?vue&type=style&index=0&id=0abc3d60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abc3d60",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0abc3d60')) {
      api.createRecord('0abc3d60', component.options)
    } else {
      api.reload('0abc3d60', component.options)
    }
    module.hot.accept("./Palette.vue?vue&type=template&id=0abc3d60&scoped=true&", function () {
      api.rerender('0abc3d60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Doc/Palette.vue"
export default component.exports